import { memo } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals"

const PrivacyPolicy = () => {

    const dispatch = useDispatch()
    const disclaimer = useSelector(state => state?.appInfo?.disclaimer);
    const modals = useSelector(state => state?.modals?.modals)

    const handleClose = () => {
        dispatch(handleModal([{ "PRIVACY_POLICY": false }]))
    }


    return (
        <>
            <BzModal size='xl' show={modals['PRIVACY_POLICY']} onHide={handleClose} centered>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Privacy Policy</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark ms-3'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                <div data-testid="disclaimer_infodata" className='infodata' dangerouslySetInnerHTML={{ __html: disclaimer }}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(PrivacyPolicy);